// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { CircleButton } = require('client-v2/common/components/buttons')

const bem = BemEntity('ShareModalShareButton')

function ShareModalShareButton(props) {
  const { shareType } = props
  return (
    tag('a', {
      className: classNames(
        props.className,
        bem.block()
      ),
      dataset: { shareType },
      href: props.href,
      rel: 'external nofollow noopener',
      target: '_blank',
      onClick: props.onClick
    },
      tag(CircleButton, {
        className: bem.element('icon', shareType)
      }),
      tag('div', {
        className: bem.element('label')
      },
        props.name
      )
    )
  )
}

ShareModalShareButton.propTypes = {
  // Values
  className: PropTypes.string,
  href: PropTypes.string,
  name: PropTypes.string.isRequired,
  shareType: PropTypes.string.isRequired,
  // Callbacks
  onClick: PropTypes.func.isRequired
}

module.exports = ShareModalShareButton
